/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileJpg = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M20 7.586V10h-2V9h-5V4H6v16h12v-1h2v3H4V2h10.414zM15 7h1.586L15 5.414z" />
        <path d="M13.023 15.517c0 .5-.148.89-.442 1.166-.29.276-.697.414-1.222.414-.211 0-.42-.024-.628-.07a1.768 1.768 0 0 1-.53-.193v-.945c.202.087.38.152.537.193.161.041.313.063.455.063.249 0 .436-.063.56-.187.129-.124.192-.304.192-.538v-2.54l-.917-.296v-.6h1.994zm7.762-3.63c.212 0 .421.019.628.055a3 3 0 0 1 .593.165v.912a4.219 4.219 0 0 0-.628-.152 3.194 3.194 0 0 0-.552-.049c-.529 0-.936.14-1.222.421-.28.276-.42.675-.42 1.195 0 .579.122 1.014.366 1.303.248.285.626.428 1.132.428.193 0 .381-.011.565-.034.023-.003.046-.009.07-.012v-.97l-.85-.28v-.58h1.856v2.463c-.16.073-.333.137-.517.192a3.64 3.64 0 0 1-.559.112 4.197 4.197 0 0 1-.594.04c-.846 0-1.488-.225-1.925-.676-.432-.45-.648-1.113-.648-1.986 0-.539.106-.996.317-1.374.217-.381.525-.672.925-.87.405-.202.893-.303 1.463-.303zm-5.065.096c.617 0 1.082.143 1.394.428.318.285.476.709.476 1.27 0 .372-.071.685-.214.938a1.327 1.327 0 0 1-.628.566c-.276.13-.618.194-1.027.194h-.725V17h-1.07v-5.017zm-.724 2.519h.504c.368 0 .627-.062.78-.187.156-.128.234-.34.234-.634 0-.3-.078-.511-.235-.635-.152-.124-.411-.186-.779-.186h-.504z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileJpg as FileJpg };
